var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "arena-chips" }, [
    _vm.canScrollPrev
      ? _c(
          "button",
          {
            staticClass: "arena-chips__next arena-chips__next--prev",
            attrs: { type: "button", "aria-label": _vm.$t("More arenas") },
            on: {
              click: function ($event) {
                return _vm.scrollBy(-1)
              },
            },
          },
          [_vm._v(" ‹ ")]
        )
      : _vm._e(),
    _c(
      "div",
      {
        ref: "track",
        staticClass: "arena-chips__track",
        class: { dragging: _vm.drag.moved },
        on: {
          scroll: _vm.measure,
          pointerdown: _vm.onDragStart,
          "!click": function ($event) {
            return _vm.onTrackClick.apply(null, arguments)
          },
        },
      },
      _vm._l(_vm.items, function (item) {
        return _c(
          "button",
          {
            key: item.key,
            staticClass: "arena-chips__chip",
            class: [item.statusClass, { active: item.active }],
            attrs: {
              type: "button",
              disabled: item.disabled,
              title: item.takenByOtherPane
                ? _vm.$t("Showing in the other screen")
                : null,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("select", item)
              },
            },
          },
          [
            item.product === "tai-xiu"
              ? _c("img", {
                  staticClass: "arena-chips__icon",
                  attrs: { src: _vm.dieImage(item.index), alt: "" },
                })
              : _c("img", {
                  staticClass: "arena-chips__icon arena-chips__icon--flag",
                  attrs: { src: _vm.flagImage(item.country), alt: "" },
                }),
            _c("span", { staticClass: "arena-chips__code" }, [
              _vm._v(_vm._s(item.code)),
            ]),
          ]
        )
      }),
      0
    ),
    _vm.canScrollNext
      ? _c(
          "button",
          {
            staticClass: "arena-chips__next",
            attrs: { type: "button", "aria-label": _vm.$t("More arenas") },
            on: {
              click: function ($event) {
                return _vm.scrollBy(1)
              },
            },
          },
          [_vm._v(" › ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }